<template>
    <Flow :app="app" />
</template>

<script>
import ANALYTICS from '@generio-ai/library-legacy/constants/analytics'
import APPS from '@generio-ai/library-legacy/constants/apps'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import Flow from '@/components/flow/Flow.vue'

export default {
    name: 'ViewCreate',
    components: {
        Flow
    },
    computed: {
        app() {
            return APPS.CREATE
        }
    },
    methods: {
        ...mapActions('analytics', [
            'logEvent'
        ]),
        ...mapActions('overlay', [
            'hide'
        ]),
    },
    mounted() {
        this.hide()
        this.logEvent({
            name: ANALYTICS.EVENTS.VIEW_OPENED,
            description: 'Create view opened',
        })
    }
}
</script>